exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.iframe[data-v-bb7f7be8]{width:100%;height:100%;border:none\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/sala_situacao/Home.vue"],"names":[],"mappings":";AA8BA,yBACE,WACA,YACA,WAAY;CACb","file":"Home.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb7f7be8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/sala_situacao/Home.vue
// module id = AEC6
// module chunks = 11